enum Permission {
  ViewRequests = "ViewRequests",
  ViewUsers = "ViewUsers",
  ViewNotifications = "ViewNotifications",
  ManageNotifications = "ManageNotifications",
  ViewRuleEngine = "ViewRuleEngine",
  ViewWallet = "ViewWallet",
  ManageRuleEngine = "ManageRuleEngine",
  ViewSettings = "ViewSettings",
  ViewRoles = "ViewRoles",
  ViewSubscriptions = "ViewSubscriptions",
  ViewDashboard = "ViewDashboard",
  ManageSettings = "ManageSettings",
  ModifyUsers = "ModifyUsers",
  ViewActivityLogs = "ViewActivityLogs",
  ManageRequests = "ManageRequests",
}

export enum LIVE_CHAT_EVENTS {
  START_CHAT = "START_CHAT",
  END_CHAT = "END_CHAT",
  NEW_MESSAGE = "NEW_MESSAGE",
  NEW_CHAT = "NEW_CHAT",
  JOIN_CHAT = "JOIN_CHAT",
  GET_CHAT_EXISTING_MESSAGES = "GET_CHAT_EXISTING_MESSAGES",
  GET_OPEN_CHATS = "GET_OPEN_CHATS",
  REJOIN_CHAT = "REJOIN_CHAT",
}
// LEAVE_CHAT event: payload expects an object with chatId for the data of the payload
// GET_ACTIVE_CHATS: does not expect any parameter for the data just like get open chats

export const Currencies = [
  "EUR",
  "USD",
  "JPY",
  "GBP",
  "AED",
  "AFN",
  "ALL",
  "AMD",
  "ANG",
  "AOA",
  "ARS",
  "AUD",
  "AWG",
  "AZN",
  "BAM",
  "BBD",
  "BDT",
  "BGN",
  "BHD",
  "BIF",
  "BMD",
  "BND",
  "BOB",
  "BRL",
  "BSD",
  "BTN",
  "BWP",
  "BYN",
  "BZD",
  "CAD",
  "CDF",
  "CHF",
  "CLP",
  "CNY",
  "COP",
  "CRC",
  "CUC",
  "CUP",
  "CVE",
  "CZK",
  "DJF",
  "DKK",
  "DOP",
  "DZD",
  "EGP",
  "ERN",
  "ETB",
  "FJD",
  "FKP",
  "GEL",
  "GGP",
  "GHS",
  "GIP",
  "GMD",
  "GNF",
  "GTQ",
  "GYD",
  "HKD",
  "HNL",
  "HRK",
  "HTG",
  "HUF",
  "IDR",
  "ILS",
  "IMP",
  "INR",
  "IQD",
  "IRR",
  "ISK",
  "JEP",
  "JMD",
  "JOD",
  "KES",
  "KGS",
  "KHR",
  "KID",
  "KMF",
  "KPW",
  "KRW",
  "KWD",
  "KYD",
  "KZT",
  "LAK",
  "LBP",
  "LKR",
  "LRD",
  "LSL",
  "LYD",
  "MAD",
  "MDL",
  "MGA",
  "MKD",
  "MMK",
  "MNT",
  "MOP",
  "MRU",
  "MUR",
  "MVR",
  "MWK",
  "MXN",
  "MYR",
  "MZN",
  "NAD",
  "NGN",
  "NIO",
  "NOK",
  "NPR",
  "NZD",
  "OMR",
  "PAB",
  "PEN",
  "PGK",
  "PHP",
  "PKR",
  "PLN",
  "PRB",
  "PYG",
  "QAR",
  "RON",
  "RSD",
  "RUB",
  "RWF",
  "SAR",
  "SEK",
  "SGD",
  "SHP",
  "SLL",
  "SLS",
  "SOS",
  "SRD",
  "SSP",
  "STN",
  "SYP",
  "SZL",
  "THB",
  "TJS",
  "TMT",
  "TND",
  "TOP",
  "TRY",
  "TTD",
  "TVD",
  "TWD",
  "TZS",
  "UAH",
  "UGX",
  "UYU",
  "UZS",
  "VES",
  "VND",
  "VUV",
  "WST",
  "XAF",
  "XCD",
  "XOF",
  "XPF",
  "ZAR",
  "ZMW",
  "ZWB",
];

// Enum for image formats
export enum ImageFormat {
  JPEG = "image/jpeg",
  PNG = "image/png",
  GIF = "image/gif",
  BMP = "image/bmp",
  SVG = "image/svg+xml",
}

// Enum for audio formats
export enum AudioFormat {
  MP3 = "audio/mpeg",
  WAV = "audio/wav",
  OGG = "audio/ogg",
  FLAC = "audio/flac",
}

// Enum for video formats
export enum VideoFormat {
  MP4 = "video/mp4",
  WEBM = "video/webm",
  OGV = "video/ogg",
  MOV = "video/quicktime",
}

export const productData = [
  {
    name: "All Packages",
    data: [
      {
        name: "Product Update",
        subData: [],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Phone Service",
          "Rule 4",
        ],
      },
      {
        name: "Waitlist",
        subData: [],
      },
    ],
  },
  {
    name: "Joble",
    data: [
      {
        name: "General Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Sophia Voice Agent",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Call Count",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Meetings & Todos Created",
        subData: ["2020", "2021", "2022", "2023", "2024", "2025", "2026"],
      },
      {
        name: "Financial Overview",
        subData: ["2020", "2021", "2022", "2023", "2024", "2025", "2026"],
      },
      {
        name: "Project KPI Settings",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Joble Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
          "Currency & Cost",
          "Currency Conversions"
        ],
      },
    ],
  },
  {
    name: "JobPays",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
  {
    name: "Echo",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Project Count",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Sprints & Todos Created",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Total Timesheet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Project KPI Settings",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Joble Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
    ],
  },
  {
    name: "JobEvent",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
  {
    name: "JobID",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Project Count",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Sprints & Todos Created",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Total Timesheet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Project KPI Settings",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Joble Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
    ],
  },
  {
    name: "JobEyes",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
  {
    name: "Caring Boss",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
];

export const currencyData = [
  {
    name: "All Packages",
    data: [
      {
        name: "Product Update",
        subData: [],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Phone Service",
          "Rule 4",
        ],
      },
      {
        name: "Waitlist",
        subData: [],
      },
    ],
  },
  {
    name: "Joble",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Call Count",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Meetings & Todos Created",
        subData: ["2020", "2021", "2022", "2023", "2024", "2025", "2026"],
      },
      {
        name: "Financial Overview",
        subData: ["2020", "2021", "2022", "2023", "2024", "2025", "2026"],
      },
      {
        name: "Project KPI Settings",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Joble Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
          "Currency & Cost",
          "Currency Conversions",
        ],
      },
    ],
  },
  {
    name: "JobPays",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
  {
    name: "Echo",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Project Count",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Sprints & Todos Created",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Total Timesheet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Project KPI Settings",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Joble Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
    ],
  },
  {
    name: "JobEvent",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
  {
    name: "JobID",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Project Count",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Sprints & Todos Created",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Total Timesheet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["2020", "2021", "2022", "2023"],
      },
      {
        name: "Project KPI Settings",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Joble Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
    ],
  },
  {
    name: "JobEyes",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
  {
    name: "Caring Boss",
    data: [
      {
        name: "Subscription Summary",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "Financial Overview",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
      {
        name: "App Usage Frequency",
        subData: ["HighestFirst", "LowestFirst", "MostRecent", "CompanySize"],
      },
      {
        name: "Rule Engine",
        subData: [
          "Autosaving",
          "Salary Disbursement Charge",
          "Payroll Vendor Charge",
          "Rule 4",
        ],
      },
      {
        name: "JobPays Wallet",
        subData: ["OneMonth", "ThreeMonths", "OneYear", "AllTime", "Custom"],
      },
    ],
  },
];
